export enum ACTION_TYPE {
    ADD_ACTION = "ADD_ACTION",
    UPDATE_ACTION = "UPDATE_ACTION"
}

export enum REPORT_NAME {
    DEPARTMENT_MASTER = "Department Master",
    PROJECT_MASTER = "Project Master",
    PROJECT_USER_MASTER = "Project User Master",
    PROJECT_TYPE_MASTER = "Project Type Master",
    PHASE_MASTER = "Phase Master",
    PROJECT_PHASE_ACTIVITY = "Project Phase Activity",
    KRA_MASTER = "Key Result Area Master",
    TIME_SHEET = "Time Sheet",
    ORGANIZATION_MASTER = "Organization Master",
    USER_MASTER = "User Master",
    USER_GROUP = "User Group",
    USER_ROLE = "User Role",
}

export enum REPORT_PATH {
    DEPARTMENT_MASTER = "departmentMaster",
    PROJECT_MASTER = "projectMaster",
    PROJECT_USER_MASTER = "projectUserMaster",
    PROJECT_TYPE_MASTER = "projectTypeMaster",
    PHASE_MASTER = "phaseMaster",
    PROJECT_PHASE_ACTIVITY = "projectPhaseActivity",
    KRA_MASTER = "kraMaster",
    TIME_SHEET = "timeSheet",
    ORGANIZATION_MASTER = "organizationMaster",
    USER_MASTER = "userMaster",
    USER_GROUP = "userGroup",
    USER_ROLE = "userRole",
}

export enum PAGE_TITLE {
    FORGOT_PASSWORD = "Forgot Password",
    RESET_PASSWORD = "Reset Password",
}